import styles from "./Navbar.module.css"
import catermatLogo from '../../../assets/images/catermatLogo.svg';
import { useState } from 'react';
import MenuBlock from "../Menu/Menu";
/**
* Navbar - pure version containing only logo.
*
* @returns TSX.Element
*/
const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false); // Toggle mobile menu
    
    return(
        <>
        <MenuBlock display={menuOpen} handleDisplay={setMenuOpen} version="onboarding"/>
            <div className={styles.Navbar}>
                <img className={styles.Logo} src={catermatLogo} alt="Catermat Logo"></img>
            </div>
        </>
    )
};

export default Navbar;